import { render, staticRenderFns } from "./My_Index.vue?vue&type=template&id=14d612a2&scoped=true&"
import script from "./My_Index.vue?vue&type=script&lang=js&"
export * from "./My_Index.vue?vue&type=script&lang=js&"
import style0 from "./My_Index.vue?vue&type=style&index=0&id=14d612a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d612a2",
  null
  
)

export default component.exports